import { EmptyState } from '../ui/EmptyState';

/**
 * D36 / E66 — the zero-results state for a NON-EMPTY filter, in both views.
 * Deliberately distinct from Terra's `Queue is empty.` copy (`QueueBody.tsx`),
 * which `PlaysPane` still renders for a genuinely empty queue (E31): "nothing
 * matches what you typed" and "you have nothing queued" are different facts,
 * and conflating them is what sends a rep hunting for a lead they did in fact
 * enroll.
 */
export function NoQueueMatches({ q }: { q: string }) {
  return <EmptyState title="No matches" description={`Nothing matches "${q}".`} />;
}
